export function validateTitle(title, gender) {
  const valuesArePopulated = !!gender && !!title;

  const checkIsValidMaleTitle = () =>
    gender === 'M' && ['LORD', 'MR', 'MASTER', 'SIR'].includes(title);

  const checkIsValidFemaleTitle = () =>
    gender === 'F' && ['LADY', 'MISS', 'MRS', 'MS'].includes(title);

  const checkIsValidNeutralTitle = () => ['DR', 'PROF', 'REV'].includes(title);

  const checkIsValidGenderTitle = () =>
    checkIsValidMaleTitle() || checkIsValidFemaleTitle() || checkIsValidNeutralTitle();

  return valuesArePopulated && checkIsValidGenderTitle();
}
